<template>
    <!-- 活动状态弹窗：已结束、未开始、已暂停 -->
    <div v-if="dialogVisible"
        class="activity-status">
        <div class="dialog-wrapper">
            <!-- 标题 -->
            <div class="title">{{ headerText }}</div>
            <!-- 图片 -->
            <div class="img-wrapper"
                :style="{ width: activityStatus === notStarted ? '42.3vw' : '50.1vw' }">
                <img :src="imgUrl" />
            </div>
            <!-- 文本区域 -->
            <div class="text-area"
                :style="{
          'margin-bottom': activityStatus === paused ? '3.03vw' : '15.95vw'
        }">
                <div class="activity-desc">{{ activityDesc }}</div>
                <div v-if="activityStatus !== notStartWrite && activityStatus !== running"
                    class="activity-during-date">{{ activityDuringDate }}</div>
                <div v-if="activityStatus == running"
                    class="write-time">{{activityWriteTime}}</div>
                <div v-if="activityStatus == running && timeIntervalState === TimeIntervalState.notStarted"
                    class="count-down">
                    <van-count-down class="count-down"
                        :time="time"
                        format="HH:mm:ss"
                        @change="onChange">
                        <template v-slot="timeData">
                            <span>填写倒计时</span>
                            <!-- 大于等于逻辑 - 防止当值为10时显示为010 -->
                            <template v-if="time >= 3600000000">
                                <span class="block">999</span>
                                <span class="colon">时</span>
                                <span class="block">59</span>
                                <span class="colon">分</span>
                                <span class="block">59</span>
                                <span class="colon">秒</span>
                            </template>
                            <template v-else>
                                <span
                                    class="block">{{ (timeData.hours+(timeData.days*24)) >= 10 ? (timeData.hours+(timeData.days*24)) : `0${(timeData.hours+(timeData.days*24))}` }}</span>
                                <span class="colon">时</span>
                                <span class="block">{{ timeData.minutes >= 10 ? timeData.minutes : `0${timeData.minutes}` }}</span>
                                <span class="colon">分</span>
                                <span class="block">{{ timeData.seconds >= 10 ? timeData.seconds : `0${timeData.seconds}` }}</span>
                                <span class="colon">秒</span>
                            </template>
                        </template>
                    </van-count-down>
                </div>
            </div>
            <!-- 关闭图标 -->
            <div class="close-icon"
                @click="close">
                <img src="../../../../static/runtime/images/magic/close-icon.png" />
            </div>
        </div>
    </div>
</template>

<script>
import { ActivityStatus, TimeIntervalState } from '../../../commons/commonVariables';
import { CountDown } from 'vant';

export default {
  components: {
    [CountDown.name]: CountDown,
  },
  props: {
    // 活动状态
    activityStatus: {
      type: String,
      default: '',
    },
    // 活动开始时间
    activityStartDate: {
      type: String,
      default: '',
    },
    // 活动结束时间
    activityEndDate: {
      type: String,
      default: '',
    },
    // 倒计时
    time: {
      type: Number,
      default: 0,
    },
    // 填写时间
    showTime: {
      type: String,
      default: '',
    },
    // 0：当天的未开始（倒计时展示） 1:当天的进行中 2:当天的已结束（时间区间展示）
    timeIntervalState: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      notStartImgUrl: 'static/image/未开始.png',
      pausedImgUrl: 'static/image/activityPaused.png',
      isOverImgUrl: 'static/image/已结束.png',
      paused: ActivityStatus.paused,
      notStarted: ActivityStatus.notStarted,
      finished: ActivityStatus.finished,
      notStartWrite: ActivityStatus.notStartWrite,
      running: ActivityStatus.running,
      dialogVisible: false,
      timeData: {},
      TimeIntervalState: TimeIntervalState,
    };
  },
  computed: {
    // 展示的图片URL
    imgUrl() {
      let res = '';
      switch (this.activityStatus) {
        case ActivityStatus.notStarted:
          res = this.notStartImgUrl;
          break;
        case ActivityStatus.paused:
          res = this.pausedImgUrl;
          break;
        case ActivityStatus.finished:
          res = this.isOverImgUrl;
          break;
        case ActivityStatus.running:
          res = this.notStartImgUrl;
          break;
        default:
          res = '';
      }
      return res;
    },
    // 标题文案
    headerText() {
      let res = '';
      if (this.activityStatus === ActivityStatus.notStarted) {
        res = '活动未开始';
      } else if (this.activityStatus === ActivityStatus.paused) {
        res = '活动已暂停';
      } else if (this.activityStatus === ActivityStatus.finished) {
        res = '活动已结束';
      } else if (this.activityStatus === ActivityStatus.running && this.timeIntervalState === TimeIntervalState.notStarted) {
        res = '未到填写时间';
      } else if (this.activityStatus === ActivityStatus.running && this.timeIntervalState === TimeIntervalState.finished) {
        res = '今天填写时间已结束';
      }
      return res;
    },
    // 活动说明
    activityDesc() {
      let res = '';
      if (this.activityStatus === ActivityStatus.notStarted) {
        res = '此活动未开始，请持续关注';
      } else if (this.activityStatus === ActivityStatus.paused) {
        res = '此活动已暂停，请持续关注';
      } else if (this.activityStatus === ActivityStatus.finished) {
        res = '很遗憾，此活动已结束';
      } else if (this.activityStatus === ActivityStatus.running && this.timeIntervalState === TimeIntervalState.notStarted) {
        res = '亲，还未到填写时间!';
      } else if (this.activityStatus === ActivityStatus.running && this.timeIntervalState === TimeIntervalState.finished) {
        res = '亲，今天填写时间已结束!';
      }
      return res;
    },
    // 表单每日填写时间
    activityWriteTime() {
      if (this.timeIntervalState === TimeIntervalState.notStarted) {
        return `每天填写期间在${this.showTime}`;
      } else {
        return `每天填写期间在${this.showTime}，请明天再来`;
      }
    },
    activityDuringDate() {
      if (this.activityStatus !== ActivityStatus.paused) {
        return `活动起止时间：${this.formatDate(this.activityStartDate)}-${this.formatDate(this.activityEndDate)}`;
      } else {
        return '';
      }
    },
  },
  created() {},
  methods: {
    open() {
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
    },
    /**
     * 格式化日期为: YYYY年MM月DD日
     * @param {string} val 日期，例："2024-01-02 23:59:59
     */
    formatDate(val) {
      if (val) {
        const YMDStr = val.split(' ')[0] || '';
        const arr = YMDStr.split('-');
        return `${arr[0] || '-'}年${arr[1] || '-'}月${arr[2] || '-'}日`;
      }
    },
    onChange(timeData) {
      this.timeData = timeData;
      // 倒计时归零了抛出事件
      if (timeData.days === 0 && timeData.hours === 0 && timeData.minutes === 0 && timeData.seconds === 0 && timeData.milliseconds === 0) {
        this.$emit('timeDownFinished');
        this.dialogVisible = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.activity-status {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  background: rgba($color: #000000, $alpha: 0.7);
  .dialog-wrapper {
    position: absolute;
    width: 85.3vw;
    background-color: #fff;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 12px;
    text-align: center;
    .title {
      font-family: HONORSansBrand-DemiBold;
      font-size: 4.8vw;
      color: #000000;
      letter-spacing: 0;
      text-align: center;
      font-weight: 600;
      margin-top: 9.08vw;
      margin-bottom: 7.27vw;
      height: 5.73vw;
    }

    .img-wrapper {
      height: 37.87vw;
      margin: 0 auto;
      margin-bottom: 9.29vw;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .text-area {
      min-height: 12.31vw;
      padding: 0 10px;
      .activity-desc {
        font-family: PingFangSC-Regular;
        font-size: 3.73vw;
        color: #000000;
        text-align: center;
        line-height: 6.13vw;
        font-weight: 400;
      }

      .activity-during-date {
        font-family: PingFangSC-Regular;
        font-size: 3.2vw;
        color: #000000;
        text-align: center;
        line-height: 6.13vw;
        font-weight: 400;
      }
      .write-time {
        font-size: 14px;
        line-height: 6.13vw;
        font-weight: 400;
        color: #000000;
      }
      .count-down {
        font-size: 14px;
        color: #999999;
      }
    }

    .close-icon {
      width: 6.67vw;
      height: 6.67vw;
      position: absolute;
      bottom: -9.33vw;
      left: 50%;
      transform: translateX(-50%);
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/customForm/activity-status-dialog.vue